<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n()
</script>

<template>
  <p class="mb-0 pb-0 mt-0 pt-[0.5rem] text-center text-sm text-communities-font-secondary">
    {{ t('payment.taxesMayApply') }}
  </p>
</template>
